<template>
  <div class="gray-back" style="height: 100%">
    
  <van-overlay :show="certLoading"    >
      <van-loading type="spinner" v-model="certLoading" style="text-align: center ; margin-top: 200px;" />
  </van-overlay>

  <van-popup v-model="certshow" style="width: 80%; height: auto ; text-align: center">
      <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
      <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
      <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
  </van-popup>

    <div class="box">
      <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
        <van-tab title="师资查询">
          <van-form
              style="margin-top: 20px"
              @submit="onSubmit"
              @failed="onFailed"
          >
            <van-cell-group>
              <van-field
                  v-model="formData.name"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  label="姓名"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入师资姓名"
              />

              <van-field
                  v-model="formData.num"
                  :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                  error-message-align="right"
                  label="身份证"
                  input-align="right"
                  clearable
                  placeholder="请输入身份证号"
              />
            </van-cell-group>

            <div style="text-align: center">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中...">搜索
              </van-button>
            </div>
          </van-form>
        </van-tab>
        <van-tab title="七彩星级运动员查询">
          <van-form
              style="margin-top: 20px"
              @submit="onSubmit2"
              @failed="onFailed"
          >
            <van-cell-group>
              <van-field
                  v-model="formData.name"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  label="姓名"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入运动员姓名"
              />

              <van-field
                  v-model="formData.num" 
                  :rules="[{ required: true, message: '请输入证件号' }]"
                  error-message-align="right"
                  label="身份证/证件号"
                  input-align="right"
                  clearable
                  placeholder="请输入证件号"
              />
            </van-cell-group>

            <div style="text-align: center">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中...">搜索
              </van-button>
            </div>
          </van-form>
        </van-tab>


      </van-tabs>


      <div v-for="(item,k) in list" :key="k">
        <van-divider>{{ item.name }}</van-divider>

        <van-cell-group>
<!--          <van-cell title="名称" :value="item.name"/>-->
          <van-cell title="类型" :value="item.type"/>
          <van-cell title="等级" :value="item.grade"/>
<!--          <van-cell title="日期" :value="item.regist_date | timeFormat" />-->
        </van-cell-group>

      </div>

      <div style="padding-bottom:200px">

        <van-cell-group v-for="(item,i) in list2" :key="i">
          <van-divider>{{ item.name }}</van-divider>

          <van-cell-group>
            <van-cell title="单位" :value="item.danwei"/>
<!--            <van-cell title="类型" :value="item.type"/>-->
            <van-cell title="星级" :value="item.grade"/>
           <van-cell title="证书下载" is-link @click="showCert(item)" />
          </van-cell-group>
        </van-cell-group>

      </div>

      <div class="" v-if="emptyShow">
        <van-empty style="margin: 10px auto" description="暂无结果"/>
      </div>
        <div v-rblink="{name:'Experience'}" style="text-align: center ; position: fixed; bottom: 1rem; left:0.5rem;right:0.5rem">
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)" 
              size="normal" round >裁判员教练员资质证书查询点这里
          </van-button>
        </div>
    </div>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-pull-refresh {
  margin-top: 0.3rem
}

.title-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.normal-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.count_edit {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';

import area from "../../../utils/area";
import validator from "../../../utils/validator";
import {
  Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button, DropdownMenu, DropdownItem,
  Tab,
  Tabs, 
  NoticeBar, Empty
} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue'; 

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
export default {
  name: 'GoodsList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Empty.name]: Empty,
    LoginDialog,
  },
  data: function () {
    return {
      validator,
      isSubmit: false,
      certLoading:false,
      loginShow: false, 
      certUrl:'',
      certshow:false,
      filename:'',
      emptyShow: false,
      showYewuPicker: false,
      showSubPicker: false,
      showArea: false,
      areaList: {},
      saveLoading: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      isApp:window.isApp(),
      params: {
        pageNo: 1,
        pageSize: 5,
        status: 0
      },
      homeTop: 0,
      list: [],
      list2: [],
      yewuColumns: [
        '考级中心/点', '先进学校'
      ],
      subColumns: [],
      subOptions: [
        {
          name: '类型',
          list: [
            {
              name: '考级点',
              value: 1,
            },
            {
              name: '考级中心',
              value: 2,
            },
          ]
        },

        {
          name: '类型',
          list: [
            {
              name: '实验学校',
              value: 1,
            },
            {
              name: '示范学校',
              value: 2,
            },
            {
              name: '实验区',
              value: 3,
            },
            {
              name: '示范区',
              value: 4,
            },
            {
              name: '实验幼儿园',
              value: 5,
            },

            {
              name: '示范幼儿园',
              value: 6,
            },
            {
              name: '实验单位',
              value: 7,
            },
            {
              name: '示范单位',
              value: 8,
            }
          ]
        }
      ],
      formData: {
        yewuIndex: 1,
        yewuName: '教练员',
        subName: '',
        subValue: '',
      },
      subColums: [],
      subLabel: ""
    }
  },
  mounted() {
    let that = this;
    document.title = "七彩查询"
    that.areaList = area;
    that.formData.yewuName = this.yewuColumns[0];
    that.subLabel = this.subOptions[0].name;
    that.formData.subName = this.subOptions[0].list[0].name;
    that.formData.subValue = this.subOptions[0].list[0].value;
    that.subColumns = this.subOptions[0].list.map(item => {
      return item.name
    });
  },
  destroyed() {
  },
  methods: {


    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    showCert(item){
      let that = this
      that.certLoading = true;
      that.$api.post('/adminapi/kaojiexame/downloadCert', {
        id:item.exame_id||'-',
        old_id:item.id, 
        is_json:1,
      }, (res) => { 
        console.log(res.data)
        that.certshow = true;
        that.certUrl = res.data.url;
        that.filename = res.data.filename;
        that.certLoading = false;
      }, (res) => {
        Toast.fail(res.msg); 
        that.certLoading = false;
      })
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/cha/exameTeacher', {
        name: that.formData.name,
        num: that.formData.num,
      }, (res) => {
        if (res.data) {
          that.list = res.data;
          if (res.data.length == 0) {
            that.emptyShow = true;
          } else {
            that.emptyShow = false;
          }
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    onSubmit2(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      that.saveLoading = true;

      that.$api.post('/api/cha/exameMember', {
        name: that.formData.name,
        num: that.formData.num,
      }, (res) => {
        if (res.data) {
          that.list2 = res.data;
          if (res.data.length == 0) {
            that.emptyShow = true;
          } else {
            that.emptyShow = false;
          }
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },


    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.list = []
      that.list2 = []
    },
    onYewuConfirm(value, index) {
      this.formData.yewuName = value;
      this.formData.yewuIndex = index + 1;
      this.subColumns = this.subOptions[index].list.map(item => {
        return item.name
      });
      this.subLabel = this.subOptions[index].name;
      if (this.subOptions[this.formData.yewuIndex - 1].list.length > 0) {
        this.formData.subName = this.subOptions[this.formData.yewuIndex - 1].list[0].name;
        this.formData.subValue = this.subOptions[this.formData.yewuIndex - 1].list[0].value
      } else {
        this.formData.subName = '';
        this.formData.subValue = 0;
      }
      this.showYewuPicker = false;
    },
    appDownload(){
        let that = this;
        console.log('downloadPic');
        appEvent({
            name: 'downloadPic',
            query: {
                filename: that.filename+'.jpg',
                url:that.certUrl,
            }
        });
    },

    onSubConfirm(value, index) {
      this.formData.subName = value;
      this.formData.subValue = this.subOptions[this.formData.yewuIndex - 1].list[index].value
      this.showSubPicker = false;
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

  }
}
</script>



// WEBPACK FOOTER //
// SearchExame.vue?e27cab06